export default __webpack_public_path__ + "static/media/Arabica-Coffee-Beans-2.fce153fe.jpg";